import { Phone, ArrowRight, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS, HERO_IMAGE } from "@/lib/siteData";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Clean modern UK home exterior"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 hero-gradient" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 w-full">
        <div className="max-w-3xl text-white fade-up">
          <div
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-sm mb-6"
            data-testid="hero-location-pill"
          >
            <MapPin className="w-4 h-4 text-green-400" />
            <span>
              Serving {BUSINESS.areas.slice(0, 3).join(", ")} &amp; surrounding areas
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Professional Exterior{" "}
            <span className="text-green-400">Cleaning</span> Across Colchester &amp; Essex.
          </h1>

          <p
            data-testid="hero-subheadline"
            className="mt-6 text-lg sm:text-xl text-white/85 max-w-2xl leading-relaxed"
          >
            High-quality exterior cleaning services for homes and businesses using
            professional equipment and safe methods to restore your property.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a href="#contact" data-testid="hero-quote-cta-link">
              <Button
                data-testid="hero-quote-cta"
                size="lg"
                className="bg-green-600 hover:bg-green-700 text-white rounded-full px-8 py-6 text-base font-semibold shadow-xl shadow-green-900/30 group"
              >
                Get a Free Quote
                <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
              </Button>
            </a>
            <a href={`tel:${BUSINESS.phoneTel}`} data-testid="hero-call-cta-link">
              <Button
                data-testid="hero-call-cta"
                size="lg"
                variant="outline"
                className="border-2 border-white/70 bg-white/10 hover:bg-white text-white hover:text-blue-700 backdrop-blur-md rounded-full px-8 py-6 text-base font-semibold"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call Now: {BUSINESS.phone}
              </Button>
            </a>
          </div>

          <p className="mt-8 text-sm text-white/70" data-testid="hero-tagline">
            {BUSINESS.tagline} <span className="text-green-300 font-semibold">{BUSINESS.slogan}</span>
          </p>
        </div>
      </div>

      {/* Decorative bottom fade */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-white/0 z-0" />
    </section>
  );
};

export default Hero;
